import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '@API/axiosNeatex';
import type { Models } from './Models';

export const addReturnsPurchase = createAsyncThunk(
  'ReturnsPurchase/addReturnsPurchase',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('ReturnsPurchase/Add', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateReturnsPurchase = createAsyncThunk(
  'ReturnsPurchase/updateReturnsPurchase',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('ReturnsPurchase/Update', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getReturnsPurchaseList = createAsyncThunk(
  'ReturnsPurchase/getReturnsPurchaseList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('ReturnsPurchase/GetList');
      if (data?.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getReturnsPurchaseById = createAsyncThunk(
  'ReturnsPurchase/getReturnsPurchaseById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`ReturnsPurchase/GetById?Id=${id}`);
      if (data?.succeeded) {
        // ===
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteReturnsPurchase = createAsyncThunk(
  'ReturnsPurchase/DeleteReturnsPurchase',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post(`ReturnsPurchase/Delete?Id=${id}`);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);



const initialState: {
  ReturnsPurchaseList: Models[];
  ReturnsPurchaseById: Models;
  loading: boolean;
  error: any | null;
} = {
  ReturnsPurchaseList: [],
  ReturnsPurchaseById: {} as Models,
  loading: false,
  error: null
};

const ReturnsPurchaseSlice = createSlice({
  name: 'ReturnsPurchase',
  initialState,
  reducers: {
    cleanUpReturnsPurchaseById: state => {
      state.ReturnsPurchaseById = {} as Models;
    }
  },
  extraReducers(builder) {
    builder

      .addCase(getReturnsPurchaseList.pending, state => {
        state.loading = true;
      })
      .addCase(getReturnsPurchaseList.fulfilled, (state, action: PayloadAction<Models[]>) => {
        state.loading = false;
        state.ReturnsPurchaseList = action.payload;
      })
      .addCase(getReturnsPurchaseList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getReturnsPurchaseById.pending, state => {
        state.loading = true;
      })
      .addCase(getReturnsPurchaseById.fulfilled, (state, action: PayloadAction<Models>) => {
        state.loading = false;
        state.ReturnsPurchaseById = action.payload;
      })
      .addCase(getReturnsPurchaseById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { cleanUpReturnsPurchaseById } = ReturnsPurchaseSlice.actions;
export default ReturnsPurchaseSlice.reducer;